import React, {useState} from 'react';
import {AurLoadingButton} from '../../../common/aur-loading-button/AurLoadingButton';
import {Link} from 'react-router-dom';

const LoadingButton: React.FC = () => {
  const [showButtonLoader, setShowButtonLoader] = useState(false);

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Loading Button</h1>
        <div>
          Button that displays a loading icon while the action is being
          processed.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurLoadingButton
            label="Click Here"
            loading={showButtonLoader}
            onClick={() => setShowButtonLoader(!showButtonLoader)}
          />
        </div>
      </div>
    </>
  );
};

export default LoadingButton;
